import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import LaptopIllustration from "../../Assets/laptop 3.png";

const LoanManagementSystem = () => {
  return (
    <>
      <Navbar />
      <main className="lms-page" role="main">
      {/* Scoped styles for LMS page */}
      <style>{`
        .lms-page {
          background: #ffffff;
          color: #1f2937;
          min-height: 100vh;
        }

        /* Hero */
        .lms-hero {
          background: linear-gradient(135deg, #065E49 0%, #118D57 50%, #16A34A 100%);
          color: #ffffff;
          overflow: hidden;
        }
        .lms-hero-inner {
          max-width: 1200px;
          margin: 0 auto;
          padding: 4.5rem 1.5rem;
          display: flex;
          gap: 2rem;
          align-items: center;
          justify-content: space-between;
        }
        .lms-hero-left {
          flex: 1 1 55%;
          display: flex;
          flex-direction: column;
          gap: 1rem;
        }
        .lms-badge {
          display: inline-flex;
          align-items: center;
          gap: .5rem;
          background: rgba(255,255,255,0.14);
          border: 1px solid rgba(255,255,255,0.3);
          color: #E7F8EF;
          padding: .35rem .75rem;
          font-weight: 700;
          border-radius: 999px;
          width: fit-content;
          backdrop-filter: blur(4px);
        }
        .lms-title {
          font-size: clamp(2rem, 4.8vw, 3.25rem);
          line-height: 1.15;
          font-weight: 800;
          margin: .25rem 0 .5rem 0;
          letter-spacing: .2px;
          text-wrap: balance;
        }
        .lms-subtitle {
          font-size: clamp(1.05rem, 2.5vw, 1.25rem);
          line-height: 1.8;
          color: #F2FFF8;
          opacity: 0.95;
          max-width: 46ch;
        }
        .lms-hero-right {
          flex: 1 1 45%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .lms-hero-illustration {
          width: 100%;
          max-width: 680px;
          height: auto;
          filter: drop-shadow(0 18px 36px rgba(0,0,0,.25));
        }

        /* Features */
        .lms-section {
          max-width: 1200px;
          margin: 0 auto;
          padding: 3.5rem 1.5rem 5rem 1.5rem;
        }
        .lms-section-header {
          margin-bottom: 1.75rem;
        }
        .lms-section-title {
          font-size: clamp(1.5rem, 3.5vw, 2rem);
          font-weight: 800;
          color: #0B3B2F;
          margin: 0 0 .5rem 0;
        }
        .lms-section-underline {
          width: 80px;
          height: 4px;
          background: linear-gradient(90deg, #118D57 0%, #5BE49B 100%);
          border-radius: 2px;
        }
        .lms-features-grid {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 1.25rem;
          margin-top: 1rem;
        }
        .lms-card {
          background: #ffffff;
          border: 1.5px solid rgba(17, 141, 87, 0.18);
          border-radius: 16px;
          padding: 1.75rem;
          box-shadow: 0 8px 30px rgba(6, 94, 73, 0.08);
          transition: transform .25s ease, box-shadow .25s ease, border-color .25s ease;
          position: relative;
          overflow: hidden;
        }
        .lms-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 3px;
          background: linear-gradient(90deg, #118D57 0%, #5BE49B 100%);
          transform: scaleX(0);
          transform-origin: left;
          transition: transform .25s ease;
        }
        .lms-card:hover {
          transform: translateY(-6px);
          box-shadow: 0 16px 44px rgba(6, 94, 73, 0.16);
          border-color: rgba(17, 141, 87, 0.35);
        }
        .lms-card:hover::before {
          transform: scaleX(1);
        }
        .lms-card-number {
          width: 48px;
          height: 48px;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 12px;
          background: rgba(91, 228, 155, 0.18);
          color: #0B604A;
          font-weight: 800;
          font-size: 1.1rem;
          margin-bottom: 1rem;
          transition: transform .25s ease, background .25s ease;
        }
        .lms-card:hover .lms-card-number {
          transform: scale(1.1) rotate(-5deg);
          background: rgba(17, 141, 87, 0.2);
        }
        .lms-card-title {
          margin: 0 0 .65rem 0;
          font-size: 1.1rem;
          font-weight: 800;
          color: #063C30;
        }
        .lms-list {
          padding-left: 1.1rem;
          margin: 0;
          display: grid;
          gap: .45rem;
        }
        .lms-list li {
          line-height: 1.6;
          color: #374151;
          font-size: 0.95rem;
        }

        /* Responsive */
        @media (max-width: 1024px) {
          .lms-hero-inner {
            padding: 3.25rem 1.25rem;
          }
          .lms-features-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        @media (max-width: 768px) {
          .lms-hero-inner {
            flex-direction: column-reverse;
            text-align: left;
            gap: 1.5rem;
          }
          .lms-hero-right {
            width: 100%;
          }
          .lms-hero-illustration {
            max-width: 560px;
          }
          .lms-features-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>

      {/* Hero */}
      <section className="lms-hero">
        <div className="lms-hero-inner">
          <div className="lms-hero-left">
            <span className="lms-badge" aria-label="Core Product">Core Product</span>
            <h1 className="lms-title">Lume Credit — Loan Management System</h1>
            <p className="lms-subtitle">
              Lume Credit is a comprehensive, end-to-end Loan Management System built to power modern lending.
              It seamlessly integrates alternative credit scoring, automated decisioning, and robust servicing
              workflows—enabling lenders to digitize onboarding, assess risk with confidence, and efficiently
              manage their entire loan lifecycle from a single, unified platform.
            </p>
          </div>

          <div className="lms-hero-right">
            <img
              src={LaptopIllustration}
              className="lms-hero-illustration"
              alt="Laptop and phone using Lume Credit LMS"
              loading="eager"
            />
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="lms-section" aria-label="LMS Capabilities">
        <header className="lms-section-header">
          <h2 className="lms-section-title">Comprehensive, Integrated Capabilities</h2>
          <div className="lms-section-underline" />
        </header>

        <div className="lms-features-grid">
          <article className="lms-card" aria-labelledby="lms-onboarding-title">
            <div className="lms-card-number">1</div>
            <h3 id="lms-onboarding-title" className="lms-card-title">Digital Onboarding</h3>
            <ul className="lms-list">
              <li>Multi-channel access: Web, App, USSD, WhatsApp</li>
              <li>KYC integration</li>
              <li>Smart storage solutions</li>
            </ul>
          </article>

          <article className="lms-card" aria-labelledby="lms-pre-title">
            <div className="lms-card-number">2</div>
            <h3 id="lms-pre-title" className="lms-card-title">Pre-Disbursement</h3>
            <ul className="lms-list">
              <li>Alternative credit scoring</li>
              <li>Automated statement upload and analysis</li>
              <li>Customizable scoring models</li>
            </ul>
          </article>

          <article className="lms-card" aria-labelledby="lms-post-title">
            <div className="lms-card-number">3</div>
            <h3 id="lms-post-title" className="lms-card-title">Post-Disbursement</h3>
            <ul className="lms-list">
              <li>PAR tracking</li>
              <li>Loan book management</li>
              <li>Financial accounting integration</li>
              <li>Integrated multi-channels communication</li>
              <li>Complete service provider visibility (auctioneers, tracking, valuers etc)</li>
            </ul>
          </article>
        </div>
      </section>
    </main>
    <Footer />
    </>
  );
};

export default LoanManagementSystem;